import React from "react";
import "./ArchiveHead.scss";
import { Timeline } from "../../Common";

const ArchiveHead = ({
  image,
  title = "Palestine Archive Collection",
  years = "1840 - 1950",
}) => {
  return (
    <section
      className="archiveHead"
      style={{
        backgroundImage: `linear-gradient(#00000070, #00000070), url(${image})`,
      }}
    >
      <div className="archiveHead-left">
        <h2 className="archiveHead-title">
          {title} <span className="archiveHead-arrow">▼</span>
        </h2>
      </div>

      <div className="ArchiveHead-timeline-wrapper">
        <Timeline />
      </div>

      <div className="archiveHead-right">
        <p className="archiveHead-years">{years}</p>
      </div>
    </section>
  );
};

export default ArchiveHead;
